import { useEffect, useState } from 'react';

export const useImageObjectUrl = (base64?: string | null) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!base64) {
      setUrl(null);
      return;
    }

    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

    const blob = new Blob([bytes], { type: 'image/jpeg' });
    const objectUrl = URL.createObjectURL(blob);

    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [base64]);

  return url;
};
